module.exports = __webpack_public_path__ + "static/media/icon_graphic.391fc7f8.svg";